<template>
    <div class="m-question m-question-type-4 mx-auto" :class="'q-'+ keys">
      <div class="m-question--slider">
        <div class="m-question--slider_panel absolute">
          <div class="m-question--slider_current absolute" :style="'width:'+ values*100 +'%;'"></div>
        </div>
        <div class="m-question--control" v-if="keys <= 5" :style="'padding-left:'+ values*100 +'%;'">
          <div class="m-question--item relative">
            <span class="m-question--item--face1" v-if="values <= 0.25"></span>
            <span class="m-question--item--face2" v-if="values > 0.25 && values <= 0.45"></span>
            <span class="m-question--item--face3" v-if="values > 0.45 && values <= 0.65"></span>
            <span class="m-question--item--face4" v-if="values > 0.65"></span>
          </div>
        </div>
        <div class="m-question--item relative" v-else>
            <span class="m-question--item--face1" v-if="values <= 0.25"></span>
            <span class="m-question--item--face2" v-if="values > 0.25 && values <= 0.45"></span>
            <span class="m-question--item--face3" v-if="values > 0.45 && values <= 0.65"></span>
            <span class="m-question--item--face4" v-if="values > 0.65"></span>
        </div>
      </div>
    </div>
</template>

<script>
import interact from 'interactjs'
export default {
  name: 'QuestionType4',
  props: {
    keys: Number
  },
  data () {
    return {
      values: null
    }
  },
  watch: {
    values: {
      handler: function (newVal) {
        const ele = this.$parent.$refs.answerBar[0]
        for (let i = 0; i < ele.children.length; i += 1) {
          ele.children[i].classList.remove('_active')
        }
        if (newVal <= 0.165) {
          this.$parent.selectAns(this.keys, 0)
          ele.children[0].classList.add('_active')
        }
        if (newVal > 0.165 && newVal <= 0.5) {
          this.$parent.selectAns(this.keys, 1)
          ele.children[1].classList.add('_active')
        }
        if (newVal > 0.5 && newVal <= 0.825) {
          this.$parent.selectAns(this.keys, 3)
          ele.children[2].classList.add('_active')
        }
        if (newVal > 0.825) {
          this.$parent.selectAns(this.keys, 5)
          ele.children[3].classList.add('_active')
        }
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      const self = this
      interact('.m-question--slider') // target elements with the 'slider' class
        .draggable({ // make the element fire drag events
          origin: 'self', // (0, 0) will be the element's top-left
          inertia: true, // start inertial movement if thrown
          modifiers: [
            interact.modifiers.restrict({
              restriction: 'self' // keep the drag coords within the element
            })
          ]
        })
        .on('dragmove', function (event) {
          const sliderWidth = interact.getElementRect(event.target.parentNode).width
          const value = event.pageX / sliderWidth
          self.values = value.toFixed(2)
        })
    })
  }
}
</script>

<style scoped lang="scss">
.m-question {
    width: calc(100% - 50px);
    max-width: 380px;
    &-type-4{
      padding: 60px 0;
    }
    &.q-0,
    &.q-1,
    &.q-2,
    &.q-3,
    &.q-4,
    &.q-5{
       .m-question--slider{
        &:after{
          position: absolute;
          content: '';
          top: 0;
          left: 0;
          width: 100%;
          // height: 100%;
          padding-bottom: 10%;
          z-index: 1;
        }
        &:before{
          position: absolute;
          content: '';
          top: 0;
          left: 0;
          width: 100%;
          // height: 100%;
          padding-bottom: 10%;
          z-index: -2;
        }
        &_current{
          height: 15px;
        }
       }
    }
    &.q-0,
    &.q-1,
    &.q-2{
      .m-question--slider{
        &_current{
          background: #D2E3B9;
        }
        &:before{
          background: url(~@/assets/ques_obj_leaf-b-xs.png)center center/contain no-repeat;
        }
        &:after{
          background: url(~@/assets/ques_obj_leaf-f-xs.png)center center/contain no-repeat;
        }
      }
      .m-question--item{
        background: url(~@/assets/ques_obj_item-1-xs.png)center center/cover no-repeat;
        &--face1{
          background: url(~@/assets/ques_obj_item-1-face-1-xs.png)center center/cover no-repeat;
        }
        &--face2{
          background: url(~@/assets/ques_obj_item-1-face-2-xs.png)center center/cover no-repeat;
        }
        &--face3{
          background: url(~@/assets/ques_obj_item-1-face-3-xs.png)center center/cover no-repeat;
        }
        &--face4{
          background: url(~@/assets/ques_obj_item-1-face-4-xs.png)center center/cover no-repeat;
        }
      }
    }
    &.q-3,
    &.q-4,
    &.q-5{
      .m-question--slider{
        &_current{
          background: #E8D1B1;
        }
        &:before{
          background: url(~@/assets/ques_obj_tree-b-xs.png)center center/contain no-repeat;
        }
        &:after{
          background: url(~@/assets/ques_obj_tree-f-xs.png)center center/contain no-repeat;
        }
      }
      .m-question--item{
        background: url(~@/assets/ques_obj_item-2-xs.png)center center/cover no-repeat;
        &--face1{
          background: url(~@/assets/ques_obj_item-2-face-1-xs.png)center center/cover no-repeat;
        }
        &--face2{
          background: url(~@/assets/ques_obj_item-2-face-2-xs.png)center center/cover no-repeat;
        }
        &--face3{
          background: url(~@/assets/ques_obj_item-2-face-3-xs.png)center center/cover no-repeat;
        }
        &--face4{
          background: url(~@/assets/ques_obj_item-2-face-4-xs.png)center center/cover no-repeat;
        }
      }
    }
    &.q-6,
    &.q-7,
    &.q-8,
    &.q-9,
    &.q-10{
      .m-question--slider{
        box-sizing: border-box;
        box-shadow: 0 3px 6px rgba($color-primary, .16);
        background: $white;
        height: 16px;
        &_current{
          height: 16px;
          background: #18A296;
        }
      }
      .m-question--item{
        background: url(~@/assets/ques_obj_owl.png)center center/cover no-repeat;
        &--face1{
          background: url(~@/assets/ques_obj_owl-face-1.png)center center/cover no-repeat;
        }
        &--face2{
          background: url(~@/assets/ques_obj_owl-face-2.png)center center/cover no-repeat;
        }
        &--face3{
          background: url(~@/assets/ques_obj_owl-face-3.png)center center/cover no-repeat;
        }
        &--face4{
          background: url(~@/assets/ques_obj_owl-face-4.png)center center/cover no-repeat;
        }
      }
    }
    &--slider{
      position: relative;
      z-index: map-get($z, 'c-h');
      border-radius: 15px;
      touch-action: none;
      width: 100%;
      height: 33px;
      &_panel{
        overflow: hidden;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
      }
      &_current{
        height: 100%;
        top: calc(50% - 8px);
        left: 0;
        border-radius: 15px;
      }
    }
    &--control{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }
    &--item{
      height: 70px;
      width: 70px;
      top: -25px;
      left: -35px;
      z-index: 2;
      &--face1,
      &--face2,
      &--face3,
      &--face4{
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
      }
    }
    @include respond-to(sm) {
        max-width: 675px;
        &.q-0,
        &.q-1,
        &.q-2,
        &.q-3,
        &.q-4,
        &.q-5{
          .m-question--slider{
            &_panel{
              width: calc(100% - 10px);
              left: 5px;
            }
            &_current{
              height: 35px;
              top: calc(50% - 0px);
            }
          }
        }
        &.q-6,
        &.q-7,
        &.q-8,
        &.q-9,
        &.q-10{
          .m-question--slider{
            height: 33px;
            &_panel{
              width: 100%;
              left: 0;
            }
            &_current{
              height: 33px;
              top: 0;
            }
          }
        }
        &--slider{
          &_panel{
            overflow: visible;
          }
        }
        &--item{
          height: 100px;
          width: 100px;
          top: -15px;
          left: -50px;
        }
    }
    @include respond-to('1200') {
      display: none;
    }
}
</style>
